import React, { useEffect, useState } from "react";
import DollarIcon from "../../../assets/user/images/whdollar-circle.svg";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import DollarImg from "../../../assets/user/images/dollar.svg";
import SearchImg from "../../../assets/user/images/search1.svg";
import ExpenseImg from "../../../assets/user/images/expense1.jpg";
import TrashImg from "../../../assets/user/images/trash.svg";
import Edit2 from "../../../assets/user/images/edit-2.svg";
import Chart2 from "../../../assets/user/images/Chart-2.jpg";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/provider/routes.utlis";
import { api } from "../../../utlis/provider/api.utlis";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Loader from "../../../layouts/loader/Loader";
import moment from "moment";
import { encode } from "base-64";
import { Line } from "react-chartjs-2";
import "chart.js/auto";

const Dashboard = () => {
  const navigate = useNavigate();
  const [dashboard, setDashboard] = useState();
  const [loading, setLoading] = useState(false);
  const [deleteExpense, setDeleteExpense] = useState({
    status: false,
    id: null,
  });
  const [deleteBudget, setDeleteBudget] = useState({
    status: false,
    id: null,
  });
  const [editBudget, setEditBudget] = useState({
    status: false,
    id: null,
    title: null,
    date: null,
    price: null,
  });
  const [limit, setLimit] = useState(false);
  const [graph, setGraph] = useState({
    day: [],
    amount: [],
  });

  const initialValues = {
    budget_title: "",
    budget: "",
    budget_date: null,
  };

  const initialEditValues = {
    budget_title: editBudget.title ?? "",
    budget: editBudget.price ?? "",
    budget_date: (editBudget.date != "" && editBudget.date != null && editBudget.date != undefined) ? moment(editBudget.date, "MM/YYYY", true).toDate() : null,
  };
  
  const validationSchema = Yup.object().shape({
    budget_title: Yup.string().required("Budget title is required!"),
    budget: Yup.string().required("Budget amount is required!"),
    budget_date: Yup.string().required("Budget month is required!"),
  });

  const deleteCareExpense = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.expenseDelete + `${deleteExpense.id}`
    );
    setDeleteExpense({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.expenseDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteMonthBudget = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.budgetDelete + `${deleteBudget.id}`
    );
    setDeleteBudget({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.expenseDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getDashboardData = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("expense dashboard => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDashboard(response.data.data);
      let day = [];
      let amount = [];
      Object.values(response.data.data.lastWeekExpenses).map((element) => {
        day.push(element.date);
        amount.push(element.value ?? 0);
      });
      setGraph({
        day: day,
        amount: amount,
      });
    } else {
      setDashboard();
      setGraph({
        day: [],
        amount: [],
      });
    }
    setLoading(false);
  };

  const setMonthlyLimit = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      budget_title: formValue.budget_title,
      budget: formValue.budget,
      budget_date: moment(formValue.budget_date).format("MM/yyyy"),
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.addBudget,
      form
    );
    setLimit(false);
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.expenseDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const editMonthlyLimit = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      budget_title: formValue.budget_title,
      budget: formValue.budget,
      budget_date: moment(formValue.budget_date).format("MM/yyyy"),
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.budgetUpdate + `${editBudget.id}`,
      form
    );
    setEditBudget({
      status: false,
      id: null,
      title: null,
      date: null,
      price: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getDashboardData(api.expenseDashboard);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDashboardData(api.expenseDashboard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="expenses-title-header">
          <h2 className="heading-title">Care Expense</h2>
          <div className="search-filter wd30">
            <div className="row g-2">
              <div className="col-md-6">
                <Link
                  className="btn-gr w-100"
                  to=""
                  onClick={() => setLimit(true)}
                >
                  Set Budget Limit
                </Link>
              </div>
              <div className="col-md-6">
                <Link className="btn-bl w-100" to={routes.expenseCreate}>
                  New Expense
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="care-expenses-section">
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <div className="care-expenses-overview gr-expenses-overview">
                    <div className="care-expenses-icon">
                      <img src={DollarIcon} />
                    </div>
                    <div className="care-expenses-text">
                      <h3>${dashboard?.budget?.currentMonthBudget ?? 0}</h3>
                      <p>This Month Budget</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="care-expenses-overview bl-expenses-overview">
                    <div className="care-expenses-icon">
                      <img src={DollarIcon} />
                    </div>
                    <div className="care-expenses-text">
                      <h3>${dashboard?.budget?.totalExpense ?? 0}</h3>
                      <p>Total Expense</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="Over-Spend-card">
                    <h2>
                      Over Spent Amount Is $
                      {dashboard?.budget?.overSpentToday ? dashboard?.budget?.overSpentToday.toFixed(2) : 0}
                    </h2>
                    <p>Added By You On {moment().format("MM-DD-yyyy")}</p>
                    <div className="Over-Spend-overview">
                      <div className="Over-Spend-item">
                        <p>Actual Spent Amount</p>
                        <h3>${dashboard?.budget?.todaySpentAmount ?? 0}</h3>
                      </div>
                      <div className="Over-Spend-item">
                        <p>Average Day Spent Limit</p>
                        <h3>${dashboard?.budget?.avgDailyLimit ?? 0}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="care-expenses-chart">
                <div className="barchartcard">
                  <Line
                    data={{
                      labels: graph.day,
                      datasets: [
                        {
                          label: "Total Expense",
                          data: graph.amount,
                          backgroundColor: "#89b0c3",
                          borderColor: "#276e91",
                          borderWidth: 1,
                          pointRadius: 3,
                          tension: 0.4,
                          fill: "origin",
                        },
                      ],
                    }}
                    options={{
                      responsive: true,
                      plugins: {
                        tooltip: {
                          callbacks: {
                            label: (context) => {
                              let value = context.raw;
                              return `$${value.toLocaleString()}`;
                            },
                          },
                        },
                      },
                      scales: {
                        y: {
                          min: 0,
                          ticks: {
                            callback: (value) => `$${value.toLocaleString()}`,
                          },
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="care-expenses-section">
          <div className="expenses-title-header">
            <h2 className="heading-title">Recent Expense Log</h2>
            <div className="search-filter wd10">
              <div className="row g-2">
                <div className="col-md-12">
                  <Link className="btn-bl wd100" to={routes.expenseList}>
                    View All
                  </Link>
                </div>
                {/* <div className="col-md-3">
                  <div className="form-group">
                    <input type="date" className="form-control" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <div className="search-form-group">
                      <input
                        type="text"
                        name=""
                        className="form-control"
                        placeholder="Search Title"
                      />
                      <span className="search-icon">
                        <img src={SearchImg} />
                      </span>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="row">
            {dashboard?.allExpenses?.length !== 0 ? (
              dashboard?.allExpenses?.map((ele, indx) => {
                return (
                  <div className="col-md-6" key={indx}>
                    <div className="log-expenses-card">
                      <div className="log-expenses-image">
                        {ele.image === null ||
                        ele.image === "" ||
                        ele.image === undefined ? (
                          <img src={NoImage} alt="" className="me-3" />
                        ) : (
                          <img src={ele.image} alt="" className="me-3" />
                        )}
                        <img src={ExpenseImg} />
                      </div>
                      <div className="log-expenses-content">
                        <div className="log-expenses-head">
                          <div className="log-expenses-tag-list">
                            <div className="tags-item1">
                              {ele.is_recurring == 1
                                ? "Recurring"
                                : "Non Recurring"}
                            </div>
                            <div className="tags-item-sub1">
                              {ele.expense_date ?? "NA"}
                            </div>
                          </div>
                          <div className="log-expenses-action">
                            <Link
                              className="edit-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.expenseEdit, {
                                  state: {
                                    id: encode(ele.id),
                                  },
                                });
                              }}
                            >
                              <img src={Edit2} />
                            </Link>
                            <Link
                              className="delete-btn"
                              to=""
                              onClick={() =>
                                setDeleteExpense({ status: true, id: ele.id })
                              }
                            >
                              <img src={TrashImg} />
                            </Link>
                          </div>
                        </div>
                        <h3 className="text-capitalize">{ele.title ?? "NA"}</h3>
                        <div className="log-expenses-price-info">
                          <div className="log-expenses-paycard text-capitalize">
                            {ele.payment_type ?? "NA"}
                          </div>
                          {ele.is_recurring == 1 ? (
                            <div className="log-expenses-price">
                              ${ele.amount ?? 0}/
                              {ele.type == "M" ? "Month" : "Year"}
                            </div>
                          ) : (
                            <div className="log-expenses-price">
                              ${ele.amount ?? 0}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>

        <div className="care-expenses-section">
          <div className="expenses-title-header">
            <h2 className="heading-title">Recent Budget Log</h2>
            <div className="search-filter wd10">
              <div className="row g-2">
                <div className="col-md-12">
                  <Link className="btn-bl wd100" to={routes.budgetList}>
                    View All
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {dashboard?.budgetList?.length !== 0 ? (
              dashboard?.budgetList?.map((ele, indx) => {
                return (
                  <div className="col-md-4" key={indx}>
                    <div className="log-expenses-card">
                      <div className="log-expenses-content">
                        <div className="log-expenses-head">
                          <div className="log-expenses-tag-list">
                            <div className="tags-item">
                              {ele.month_name ?? "NA"}
                            </div>
                          </div>
                          <div className="log-expenses-action">
                            <Link
                              className="edit-btn mx-1"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                setEditBudget({
                                  status: true,
                                  id: ele.id,
                                  title: ele.budget_title,
                                  date: ele.budget_date,
                                  price: ele.budget,
                                });
                              }}
                            >
                              <img src={Edit2} />
                            </Link>
                            <Link
                              className="delete-btn"
                              to=""
                              onClick={() =>
                                setDeleteBudget({ status: true, id: ele.id })
                              }
                            >
                              <img src={TrashImg} />
                            </Link>
                          </div>
                        </div>
                        <h3 className="text-capitalize">
                          {ele.budget_title ?? "NA"}
                        </h3>
                        <div className="log-expenses-price-info">
                          <div className="log-expenses-price">
                            ${ele.budget ?? 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5% 0",
                }}
              >
                <img width={300} src={NoData} alt="" />
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={limit}
        onHide={() => {
          setLimit(false);
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Set Monthly Budget Limit</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={setMonthlyLimit}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="findcare-card">
                      <div className="col-md-12 mb-3">
                        <div className="form-group mb-1">
                          <h4>Enter Budget Title</h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="budget_title"
                            placeholder="Enter Budget Title"
                          />
                        </div>
                        <ErrorMessage
                          name="budget_title"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Choose Budget Month</h4>
                          <Field name="budget_date" className="form-control">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                minDate={new Date()}
                                selected={values.budget_date || ""}
                                onChange={(value) =>
                                  setFieldValue("budget_date", value)
                                }
                                showIcon
                                showMonthYearPicker
                                dateFormat={"MM/yyyy"}
                                className="form-control"
                                style={{ padding: "15px 40px" }}
                                autoComplete="off"
                                placeholderText="Select Month"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="budget_date"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group search-form-group mb-1">
                          <h4>Enter Budget Amount</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="budget"
                            placeholder="Enter Budget Amount"
                          />
                          <span className="form-group-icon">
                            <img src={DollarImg} />
                          </span>
                        </div>
                        <ErrorMessage
                          name="budget"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="form-group text-end mt-3">
                        <button
                          type="button"
                          onClick={() => {
                            setLimit(false);
                          }}
                          className="btn btn-re me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-gr me-2"
                          data-bs-dismiss="modal"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editBudget.status}
        onHide={() => {
          setEditBudget({
            status: false,
            id: null,
            title: null,
            date: null,
            price: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Monthly Budget Limit</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialEditValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={editMonthlyLimit}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="findcare-card">
                      <div className="col-md-12 mb-3">
                        <div className="form-group mb-1">
                          <h4>Enter Budget Title</h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="budget_title"
                            placeholder="Enter Budget Title"
                          />
                        </div>
                        <ErrorMessage
                          name="budget_title"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Choose Budget Month</h4>
                          <Field name="budget_date" className="form-control">
                            {({ field }) => (
                              <DatePicker
                                {...field}
                                minDate={new Date()}
                                selected={values.budget_date || ""}
                                onChange={(value) =>
                                  setFieldValue("budget_date", value)
                                }
                                showIcon
                                showMonthYearPicker
                                dateFormat={"MM/yyyy"}
                                className="form-control"
                                style={{ padding: "15px 40px" }}
                                autoComplete="off"
                                placeholderText="Select Month"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="budget_date"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group search-form-group mb-1">
                          <h4>Enter Budget Amount</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="budget"
                            placeholder="Enter Budget Amount"
                          />
                          <span className="form-group-icon">
                            <img src={DollarImg} />
                          </span>
                        </div>
                        <ErrorMessage
                          name="budget"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="form-group text-end mt-3">
                        <button
                          type="button"
                          onClick={() => {
                            setEditBudget({
                              status: false,
                              id: null,
                              title: null,
                              date: null,
                              price: null,
                            });
                          }}
                          className="btn btn-re me-2"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-gr me-2"
                          data-bs-dismiss="modal"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteExpense.status}
        onHide={() => {
          setDeleteExpense({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Care Expense</h5>
                <p className="text-center">
                  Deleting this care expense cannot be undone. Are you sure you
                  want to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteExpense({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteCareExpense()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteBudget.status}
        onHide={() => {
          setDeleteBudget({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Budget</h5>
                <p className="text-center">
                  Deleting this budget cannot be undone. Are you sure you want
                  to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteBudget({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteMonthBudget()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Dashboard;
